import React from 'react';
import RedirectsGridActions from './RedirectsGridActions';

const redirectsGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        Header: 'Website',
        accessor: 'site_name',
        width: 200,
    },
    {
        Header: 'Redirect From',
        accessor: 'redirect_from',
        sortable: false,
    },
    {
        Header: 'Redirect To',
        accessor: 'redirect_to',
        sortable: false,
    },
    {
        Header: 'Total',
        accessor: 'count',
        sortable: false,
        width: 100,
    },
    {
        Header: 'Status',
        accessor: 'status',
        sortable: false,
        width: 100,
    },
    {
        Header: 'Date',
        accessor: 'updated_at',
        sortable: false,
        width: 150,
    },
    {
        Header: 'Actions',
        width: 100,
        sortable: false,
        Cell: (props) => <RedirectsGridActions props={props} />,
    },
];

export default redirectsGridColumns;



// WEBPACK FOOTER //
// ./src/containers/redirects/RedirectsGridColumns.jsx